<div class="ttm-page-title-row" style="background: #293649;">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="title-box text-center">
                    <div class="page-title-heading">
                        <h1 class="title" style="color:white"> Directors & Advisors</h1>
                    </div><!-- /.page-title-captions -->
                </div>
            </div><!-- /.col-md-12 -->
        </div><!-- /.row -->
    </div><!-- /.container -->
</div>
<div class="site-main">

    <section class="ttm-row clearfix">
        <div class="container">
            <!-- row -->
            <div class="mt_10 mb_10 row slick_slider">
                <div class="col-lg-4">
                    <!-- featured-imagebox-team -->
                    <div class="featured-imagebox featured-imagebox-team style4 p-30">
                        <div class="ttm-box-view-overlay">
                            <div class="featured-thumbnail">
                                <!-- featured-thumbnail -->
                                <img class="img-fluid" src="assets/images/CEO-Pic-transformed.png" alt="image">
                            </div>
                        </div>
                        <div class="featured-content">
                            <div class="featured-title">
                                <!-- featured-title -->
                                <h5><a href="#">Sandip Mohapatra</a></h5>
                            </div>
                            <!--<p class="category">
                                        CEO
                                    </p>--><!-- category -->
                            <div class="mb_10"></div>
                            <div class="featured-iconbox ttm-media-link">
                                <div class="media-block">
                                    <a target="_blank" href="https://www.linkedin.com/in/sandipmohapatrausa/"
                                        class="media-btn" tabindex="0"><i class="fa fa-linkedin"></i></a>

                                </div>
                            </div>
                        </div>
                    </div><!-- featured-imagebox-team end-->
                </div>
                <div class="col-lg-4">
                    <!-- featured-imagebox-team -->
                    <div class="featured-imagebox featured-imagebox-team style4 p-30">
                        <div class="ttm-box-view-overlay">
                            <div class="featured-thumbnail">
                                <!-- featured-thumbnail -->
                                <img class="img-fluid" src="assets/images/wayle-johnson-transformed.png" alt="image">
                            </div>
                        </div>
                        <div class="featured-content">
                            <div class="featured-title">
                                <!-- featured-title -->
                                <h5><a href="#">Wayne Johnson</a></h5>
                            </div>

                            <div class="featured-iconbox ttm-media-link">
                                <div class="media-block">
                                    <a target="_blank" href="https://www.linkedin.com/in/waynejohn3/" class="media-btn"
                                        tabindex="0"><i class="fa fa-linkedin"></i></a>

                                </div>
                            </div>
                        </div>
                    </div><!-- featured-imagebox-team end-->
                </div>
                <div class="col-lg-4">
                    <!-- featured-imagebox-team -->
                    <div class="featured-imagebox featured-imagebox-team style4 p-30">
                        <div class="ttm-box-view-overlay">
                            <div class="featured-thumbnail">
                                <!-- featured-thumbnail -->
                                <img class="img-fluid" src="assets/images/DSC_0106-NxNhyDw03-transformed.png" alt="image">
                            </div>
                        </div>
                        <div class="featured-content">
                            <div class="featured-title">
                                <!-- featured-title -->
                                <h5><a href="#">Atul Garg</a></h5>
                            </div>

                            <div class="featured-iconbox ttm-media-link">
                                <div class="media-block">
                                    <a target="_blank" href="https://www.linkedin.com/in/atulgarg1/" class="media-btn"
                                        tabindex="0"><i class="fa fa-linkedin"></i></a>

                                </div>
                            </div>
                        </div>
                    </div><!-- featured-imagebox-team end-->
                </div>
                <div class="col-lg-4">
                    <!-- featured-imagebox-team -->
                    <div class="featured-imagebox featured-imagebox-team style4 p-30">
                        <div class="ttm-box-view-overlay">
                            <div class="featured-thumbnail">
                                <!-- featured-thumbnail -->
                                <img class="img-fluid" src="assets/images/keith-transformed.png" alt="image">
                            </div>
                        </div>
                        <div class="featured-content">
                            <div class="featured-title">
                                <!-- featured-title -->
                                <h5><a href="#">Keith Omsberg</a></h5>
                            </div>

                            <div class="featured-iconbox ttm-media-link">
                                <div class="media-block">
                                    <a target="_blank" href="https://www.linkedin.com/in/keith-o-938887/"
                                        class="media-btn" tabindex="0"><i class="fa fa-linkedin"></i></a>

                                </div>
                            </div>
                        </div>
                    </div><!-- featured-imagebox-team end-->
                </div>
                <div class="col-lg-4">
                    <!-- featured-imagebox-team -->
                    <div class="featured-imagebox featured-imagebox-team style4 p-30">
                        <div class="ttm-box-view-overlay">
                            <div class="featured-thumbnail">
                                <!-- featured-thumbnail -->
                                <img class="img-fluid" src="assets/images/SanatPic-transformed.png" alt="image">
                            </div>
                        </div>
                        <div class="featured-content">
                            <div class="featured-title">
                                <!-- featured-title -->
                                <h5><a href="#">Sanat Mohapatra</a></h5>
                            </div>
                            <!--<p class="category">Manager Quality Assurance</p>--><!-- category -->
                            <div class="featured-iconbox ttm-media-link">
                                <div class="media-block">
                                    <a target="_blank" href="https://www.linkedin.com/in/sanat-mohapatra-51973799/"
                                        class="media-btn" tabindex="0"><i class="fa fa-linkedin"></i></a>

                                </div>
                            </div>
                        </div>
                    </div><!-- featured-imagebox-team end-->
                </div>


                <div class="col-lg-4">
                    <!-- featured-imagebox-team -->
                    <div class="featured-imagebox featured-imagebox-team style4 p-30">
                        <div class="ttm-box-view-overlay">
                            <div class="featured-thumbnail">
                                <!-- featured-thumbnail -->
                                <img class="img-fluid" src="assets/images/subrat.png" alt="image">
                            </div>
                        </div>
                        <div class="featured-content">
                            <div class="featured-title">
                                <!-- featured-title -->
                                <h5><a href="#">Subrat Sahoo</a></h5>
                            </div>
                            <!--<p class="category">Manager Quality Assurance</p>--><!-- category -->
                            <div class="featured-iconbox ttm-media-link">
                                <div class="media-block">
                                    <a target="_blank" href="https://www.linkedin.com/in/subrat-kumar-sahoo-60981819/"
                                        class="media-btn" tabindex="0"><i class="fa fa-linkedin"></i></a>

                                </div>
                            </div>
                        </div>
                    </div><!-- featured-imagebox-team end-->
                </div>


            </div><!-- row end -->
        </div>
    </section>

</div>